import React, { useEffect, useState } from 'react';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Separator } from '../../components/ui/separator';
import { Mail, Lock, Shield, ArrowLeft,LockIcon } from 'lucide-react';
import { Toaster, toast } from 'sonner';
import logoSm from "assets/images/logo-sm.png";

import { GoogleOAuthProvider, useGoogleLogin } from "@react-oauth/google";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '../../components/ui/tabs'; // shadcn/ui Tabs
import relibuildLogoDark from '../../assets/images/logo-dark.png';
import relibuildLogoLight from '../../assets/images/logo-light.png';
import tradesmenLogoDark from '../../assets/images/tradesmen-logo-dark.png';
import tradesmenLogoLight from '../../assets/images/tradesmens-white.png';
import { jwtDecode } from "jwt-decode";
import { CallAPIPostPromise, blueColor2, deepBlue, grayColor, primaryColor } from 'Common/commaon';
import { getDecodeUserTermsAccepted, getDecodeUserType, loginUser, otpVerification, succefullLogin } from 'slices/auth/login/thunk';
import { useDispatch } from 'react-redux';
import { loginSuccess } from 'slices/auth/login/reducer';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import TermsAndConditions from './termsAndCondition';
import LayoutModeDropdown from 'Common/LayoutModeDropdown';
import './login-screen.css';
declare global {
  interface Window {
    FB: any;
  }
}

const getSafeAutoLoginPath = (path: string | null) => {
  if (!path) return "";

  const normalizedPath = `/${path.replace(/^\/+/, "")}`;
  if (
    normalizedPath.includes("..") ||
    normalizedPath.includes("\\") ||
    normalizedPath.includes("://") ||
    !/^\/[a-zA-Z0-9/_-]+$/.test(normalizedPath)
  ) {
    return "";
  }

  return normalizedPath;
};

const isValidEmail = (value: string) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());

export function LoginScreen2() {
  const [email, setEmail] = useState('');
  const [loginData,setLoginData]=useState('')
  const [otp, setOtp] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
   const [createNewPassword,setCreateNewPassword] = useState(false)
  const [googleLoading,setGoogleLoading] = useState(false)
  const [isEmailConfirmed, setIsEmailConfirmed] = useState(false); // user exists confirmed
const [otpSessionId, setOtpSessionId] = useState<string | null>(null); // session id from backend
const [otpForVerification, setOtpForVerification] = useState("");
const [otpVerifiedClient, setOtpVerifiedClient] = useState(false);
const [confirmPassword, setConfirmPassword] = useState("");
const [password, setPassword] = useState('');

  const handleFacebookLogin = async () => {
    setIsLoading(true);
    try {
      await new Promise((resolve) => setTimeout(resolve, 1000));
      toast.success('Facebook login would redirect to OAuth flow');
    } catch {
      toast.error('Failed to initiate Facebook login');
    } finally {
      setIsLoading(false);
    }
  };

  // Send OTP
  const handleSendOTP = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) {
      toast.error('Please enter your email address');
      return;
    }
    if (!isValidEmail(email)) {
      toast.error('Please enter a valid email address');
      return;
    }
    setIsLoading(true);
    try {
      const user = {
        email:email

      }
    setOtp("");
    setOtpSessionId(null);
    await dispatch(loginUser(user,navigate,setOtpSent,setOtpSessionId))
    
      
      // toast.success('OTP sent to your email address');
    } catch {
      toast.error('Failed to send OTP');
    } finally {
      setIsLoading(false);
    }
  };

  // Verify OTP
  const handleVerifyOTP = async (e?: React.FormEvent) => {
    if(e){
      e.preventDefault();

    }
    if (!otp) {
      toast.error('Please enter the OTP');
      return;
    }
    if (!otpSessionId) {
      toast.error('Your OTP session is missing. Please request a new code.');
      setOtpSent(false);
      return;
    }
    setIsLoading(true);
    try {
      await dispatch(otpVerification({
        otp,
        sessionId: otpSessionId
      }, navigate, setLoginData));
    } catch (error: any) {
      toast.error(error?.response?.data?.message || 'Invalid or expired OTP. Please request a new code.');
    } finally {
      setIsLoading(false);
    }
 
  };

  // Password login
  const handlePasswordLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !password) {
      toast.error('Please enter your email and password');
      return;
    }
    if (!isValidEmail(email)) {
      toast.error('Please enter a valid email address');
      return;
    }
    setIsLoading(true);
    CallAPIPostPromise("/login/login-with-password",{
      email:email,
      password:password,
      loginSource: "relibuild-admin",
      device: "web"
    }).then((res:any)=>{
   if(!res.data.token){
    if(res.data.message ==="Password not created"){
      setOtp("")
      setOtpSent(false)
      setPassword("")
      setConfirmPassword("")
  setCreateNewPassword(true)
    }
   }else{
    let data = res.data;
    if (data) {
      succefullLogin(data,dispatch,navigate,setLoginData)
    }
   }
    }).catch((e:any)=>{
      console.log({
        ...e
      })
      toast.warning(e?.response?.data?.message|| e.message||"Failed")
    }).finally(()=>{
      setIsLoading(false)
    })
  };
const dispatch:any = useDispatch()
  const resetOTPFlow = () => {
    setOtpSent(false);
    setOtp('');
    setOtpSessionId(null);
  };
  const navigate = useNavigate()
  const handleGoogleLogin = useGoogleLogin({
    flow: "implicit",
    onSuccess: (tokenResponse:any) => {
      setGoogleLoading(true)
      // const userInfo: any = jwtDecode(tokenResponse.credential || "");
      CallAPIPostPromise('/login/verify-google-login',{
        access_token:tokenResponse.access_token,
        loginSource: "relibuild-admin",
        device: "web"
      }).then((response:any)=>{
        let data = response.data;
        if (data) {
          succefullLogin(data,dispatch,navigate,setLoginData)
        }
      }).catch((e)=>{
        console.log(e)
        toast.error(e.message||"Something went wrong")
      }).finally(()=>{
        setGoogleLoading(false)
      })
    },
    onError: () => {
      toast.error("Google login failed");
    },
  });
  useEffect(() => {
    if (!window.FB) return;

    window.FB.init({
      appId: '1962756437881341',
      cookie: true,
      xfbml: false, // we don't need XFBML tags
      version: 'v17.0',
    });
  }, []);

  const handleSendOtpForCreatePasswrod = ()=>{
    if(!email) { toast.error("Enter email"); return; }
    if(!isValidEmail(email)) { toast.error("Please enter a valid email address"); return; }
    setIsLoading(true);
    CallAPIPostPromise("/login/send-creatPassword-otp",{ email }).then((res:any)=>{
      toast.success(res.message || "User found");
      setOtpSessionId(res.sessionId);
      setOtpSent(true)
    }).catch((err:any)=>{
      toast.error(err?.message || "User not found");

    }).finally(()=>{
      setIsLoading(false)
    })
  }

  const handleFBLogin = () => {
    window.FB.login(
      (response: any) => {
        // send response.authResponse.accessToken to backend for verification
      },
      { scope: "email,public_profile" }
    );
  };
  const hostname = window.location.hostname;
  const isRelibuildBrand = hostname.includes("relibuild");
  const lightModeLogo = isRelibuildBrand ? relibuildLogoDark : tradesmenLogoDark;
  const darkModeLogo = isRelibuildBrand ? relibuildLogoLight : tradesmenLogoLight;
  const brandName = isRelibuildBrand ? "RELiBUILD" : "The Tradesmen's Collective";
  const [searchParams] = useSearchParams();

  // get token value from query param
  const browserToken = searchParams.get("token");
  const browserPath = searchParams.get("path");
  const tag = searchParams.get("tag");
  const action = searchParams.get("action");
  useEffect(() => {
    if (!browserToken) return;

    localStorage.setItem("token", browserToken);
    localStorage.setItem("authUser", JSON.stringify(browserToken));
    dispatch(loginSuccess({ token: browserToken }));

    const userType = getDecodeUserType();
    const requestedPath = getSafeAutoLoginPath(browserPath);
    const defaultPath = userType === "admin" || userType === "homeowner" || userType === "real_estate_agent" || userType === "broker"
      ? "/dashboard"
      : "/pages-profile-settings";
    const destinationParams = new URLSearchParams();
    if (tag) destinationParams.set("tag", tag);
    if (action) destinationParams.set("action", action);
    const destinationQuery = destinationParams.toString();
    const destination = `${requestedPath || defaultPath}${destinationQuery ? `?${destinationQuery}` : ""}`;

    navigate(destination, { replace: true });
  }, [action, browserPath, browserToken, dispatch, navigate, tag]);
  return (

    <div className='tailwind-prefix login-screen'>

 <div className="login-screen__backdrop min-h-screen bg-[#EBF4FF] flex items-center justify-center p-2">
      <div className="login-screen__appearance" aria-label="Appearance settings">
        <LayoutModeDropdown />
      </div>
      <div className="login-screen__shell w-full max-w-md ">
        {/* Header */}
        <div className="login-screen__brand text-center ">
          <div className="flex items-center justify-center space-x-2 mb-2">
            <img
              src={lightModeLogo}
              className="login-screen__brand-logo login-screen__brand-logo--light h-[70px]"
              alt={brandName}
            />
            <img
              src={darkModeLogo}
              className="login-screen__brand-logo login-screen__brand-logo--dark h-[70px]"
              alt=""
              aria-hidden="true"
            />
          </div>
        </div>

        {/* Login Card */}
        <Card className="login-screen__card border-0 shadow-xl bg-white/95 backdrop-blur-sm">
          <CardHeader className="login-screen__header text-center">
            <CardTitle className="text-xl"> {createNewPassword? !otpVerifiedClient?"We need to verify email":"Create New Password":"Welcome Back"}</CardTitle>
            <div>
              {createNewPassword?!otpVerifiedClient? !otpSent?`We'll send a one-time code to this email`:`OTP sent to ${email}`:`Create new password from here`:`Sign in to your ${brandName} account`}
              
            </div>
          </CardHeader>
{!createNewPassword &&       <CardContent className="">
            {/* Google Login */}
            <Button
              variant="outline"
              className="w-full mb-2 h-12 mt-3 bg-white border-gray-200 hover:bg-gray-50"
              onClick={()=>{
                handleGoogleLogin()
              }}
              disabled={isLoading}
            >
              {googleLoading ?          <Spinner size={'sm'} animation="border" role="status" />:<svg className="w-5 h-5 mr-2" viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                />
                <path
                  fill="currentColor"
                  d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                />
                <path
                  fill="currentColor"
                  d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                />
                <path
                  fill="currentColor"
                  d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                />
              </svg>}
              
              Continue with Google
            </Button>

            {/* Facebook Login */}
            {/* <Button
              variant="outline"
              className="w-full h-12 bg-white border-gray-200 hover:bg-gray-50"
              onClick={handleFBLogin}
              disabled={isLoading}
            >
              <svg
                className="w-5 h-5 mr-2 text-blue-600"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="M22 12a10 10 0 1 0-11.5 9.9v-7h-2v-3h2v-2.3c0-2 1.2-3.2 3-3.2.9 0 1.8.1 1.8.1v2h-1c-1 0-1.3.6-1.3 1.2V12h2.3l-.4 3h-1.9v7A10 10 0 0 0 22 12"
                />
              </svg>
              Continue with Facebook
            </Button> */}

            {/* Divider */}
            <div className="login-screen__divider relative my-6 flex items-center w-full ">
  <div style={{
    borderTop:"1px solid #d1d5db"
  }} className="flex-grow  "></div>
  <span className="flex-shrink mx-2 text-sm text-gray-500 bg-white px-2">
    Or continue with email
  </span>
  <div style={{
    borderTop:"1px solid #d1d5db"
  }} className="flex-grow"></div>
</div>


            {/* Tabs for OTP vs Password */}
            <Tabs defaultValue="otp" className="login-screen__tabs w-full">

            <TabsList className="grid grid-cols-2 w-full mb-3">
    
    <TabsTrigger
      value="otp"
      className="transition-all duration-300 border-0"
    >
      Login with OTP
    </TabsTrigger>
    <TabsTrigger
      value="password"
      className="transition-all duration-300 border-0"

    >
      Login with Password
    </TabsTrigger>
  
  </TabsList>
              {/* OTP Tab */}
              <TabsContent value="otp">
                {!otpSent ? (
                  <form onSubmit={handleSendOTP} className="space-y-4" noValidate>
                    <Label>Email Address</Label>
                    <div className="login-screen__field flex bg-[#F3F3F5] items-center rounded-md">
                      <Mail className="ml-3 h-4 w-4 text-muted-foreground" />
                      <Input
                        type="email"
                        placeholder="contractor@example.com"
                        value={email}
                    
                        onChange={(e) => setEmail(e.target.value)}
                        className="h-12 placeholder:text-sm text-sm bg-transparent border-0"
                        required
                      />
                    </div>
                    <Button
                      type="submit"
                      className="w-full h-12 border-0 bg-blue-600 hover:bg-blue-700 text-white"
                      disabled={isLoading}
                    >
                      {isLoading ?<div className='flex items-center'>
                        <Spinner size={'sm'} className='mr-2' animation="border" role="status" /> Sending OTP
                        </div> : 'Send Verification Code'}
                    </Button>
                  </form>
                ) : (
                  <form onSubmit={handleVerifyOTP} className="space-y-4" noValidate>
                    <Button
                      variant="ghost"
                      type="button"
                      onClick={resetOTPFlow}
                      className="login-screen__back-button justify-start border-0 p-0 h-auto hover:bg-transparent"
                    >
                      <ArrowLeft className="h-4 w-4 mr-2" />
                      Back to email entry
                    </Button>
                    <Label>Verification Code</Label>
                    <Input
                      type="text"
                      inputMode="numeric"
                      pattern="[0-9]{4}"
                      placeholder="Enter 4-digit code"
                      value={otp}
                      onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 4))}
                      className="login-screen__otp-input text-center text-lg tracking-widest h-12"
                      maxLength={4}
                      autoComplete="one-time-code"
                      required
                    />
                    <Button
                      type="submit"
                      className="login-screen__otp-submit w-full h-12 border-0 bg-blue-600 text-white"
                      disabled={isLoading || otp.length !== 4}
                    >
                      {isLoading ? 'Verifying...' : 'Verify & Sign In'}
                    </Button>
                  </form>
                )}
              </TabsContent>

              {/* Password Tab */}
              <TabsContent value="password">
  <form onSubmit={handlePasswordLogin} className="space-y-4" noValidate>
    <Label>Email Address</Label>
    <div className="login-screen__field flex bg-[#F3F3F5] items-center rounded-md">
      <Mail className="ml-3 h-4 w-4 text-muted-foreground" />
      <Input
        type="email"
        placeholder="contractor@example.com"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="h-12 bg-transparent border-0"
        required
      />
    </div>

    <Label>Password</Label>
    <div className="login-screen__field flex bg-[#F3F3F5] items-center rounded-md">
      <LockIcon className="ml-3 h-4 w-4 text-muted-foreground" />
      <Input
        type="password"
        placeholder="Enter your password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        className="h-12 bg-transparent border-0"
        required
      />
    </div>

    {/* Forgot password link */}
    <div className="flex justify-end ">
      <button
        type="button"
        onClick={() =>{
          setOtp("")
          setOtpSent(false)
          setPassword("")
      setConfirmPassword("")
          setCreateNewPassword(true)
        }} // modal ya page open karne ke liye
        className="text-sm bg-transparent border-0 text-blue-600 hover:underline"
      >
        Forgot password?
      </button>
    </div>

    <Button
      type="submit"
      className="w-full h-12 bg-blue-600 hover:bg-blue-700 border-0 text-white"
      disabled={isLoading}
    >
      {isLoading ? "Logging in..." : "Login"}
    </Button>
  </form>
</TabsContent>

            </Tabs>

       
          </CardContent>}

{createNewPassword && (
  <CardContent className="">
    {/* Step A: Confirm email belongs to a user */}
    {!otpSent  && (
      <form onSubmit={async (e) => {
          e.preventDefault();
       handleSendOtpForCreatePasswrod()
       
      }} className="space-y-4" noValidate>
        <Label>Confirm Email</Label>
        <div className="login-screen__field flex bg-[#F3F3F5] items-center rounded-md">
          <Mail className="ml-3 h-4 w-4 text-muted-foreground" />
          <Input type="email" placeholder="your@example.com" value={email}
            onChange={(e)=>setEmail(e.target.value)} className="h-12 bg-transparent border-0" required />
        </div>
        <Button type="submit" className="w-full h-12 border-0 text-white bg-blue-600" disabled={isLoading}>
          {isLoading ? "Checking..." : "Send verification code"}
        </Button>
      </form>
    )}


    {/* Step B: Send OTP & verify ownership */}
    {otpSent && !otpVerifiedClient && (
      <div className="space-y-4">
        {/* Send OTP */}
          <form onSubmit={async (e) => {
            e.preventDefault();
            if(!otpForVerification) { toast.error("Enter OTP"); return; }
            setIsLoading(true);
            CallAPIPostPromise("/login/verify-creatPassword-otp",{
              email,
              otp: otpForVerification,
              sessionId: otpSessionId
            }).then((res:any)=>{
             const data = res?.data
              if(data.newSessionId){
                 toast.success(data.message || "OTP verified");
                 setOtpVerifiedClient(true); // now allow password creation
                 setOtpSessionId(data.newSessionId)
              }
              
            }).catch((err:any)=>{
              toast.error(err?.message || "Invalid OTP");

            }).finally(()=>{
              setIsLoading(false)
            })
         
          }} className="space-y-4" noValidate>
            <Label>Enter code</Label>
            <Input type="text" placeholder="Enter OTP" value={otpForVerification}
              onChange={(e)=>setOtpForVerification(e.target.value)} className="h-12 text-center" required />
            <div className="flex gap-2">
              <Button type="submit" className="flex-1 h-12 bg-blue-600 border-0 text-white" disabled={isLoading}>
                {"Verify"}
              </Button>
              <Button type="button" variant="ghost"  onClick={async ()=>{
              handleSendOtpForCreatePasswrod()
              }} className="h-12 border-0">Resend</Button>
            </div>
          </form>
      </div>
    )}

    {/* Step C: Create new password (only when otpVerifiedClient === true) */}
    {otpVerifiedClient && (
  <form
    onSubmit={async (e) => {
      e.preventDefault();

      if (!password) {
        toast.error("Enter new password");
        return;
      }
      if (!confirmPassword) {
        toast.error("Enter confirm password");
        return;
      }
      if (password !== confirmPassword) {
        toast.error("Passwords do not match");
        return;
      }

      setIsLoading(true);
      CallAPIPostPromise("/login/createPassword",{
        email,
        newPassword: password,
        sessionId: otpSessionId,
        otp:otpForVerification
      }).then((res:any)=>{
        toast.success(res.message || "Password set successfully");
        setCreateNewPassword(false);
        setIsEmailConfirmed(false);
        setOtpSessionId(null);
        setOtpForVerification("");
        setOtpVerifiedClient(false);
        setPassword("");
        setOtpSent(false)
        setConfirmPassword("");
      }).finally(()=>{
        setIsLoading(false);

      })
   
    }}
    className="space-y-4"
    noValidate
  >
    <Label>Set New Password</Label>
    <div className="login-screen__field flex bg-[#F3F3F5] items-center rounded-md">
      <LockIcon className="ml-3 h-4 w-4 text-muted-foreground" />
      <Input
        type="password"
        placeholder="Enter new password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        className="h-12 bg-transparent border-0"
        required
      />
    </div>

    <div className="login-screen__field flex bg-[#F3F3F5] items-center rounded-md">
      <LockIcon className="ml-3 h-4 w-4 text-muted-foreground" />
      <Input
        type="password"
        placeholder="Confirm new password"
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
        className="h-12 bg-transparent border-0"
        required
      />
    </div>

    <Button
      type="submit"
      className="w-full h-12 border-0 text-white bg-blue-600"
      disabled={isLoading}
    >
      {isLoading ? "Saving..." : "Set New Password"}
    </Button>
  </form>
)}

  </CardContent>
)}


   
        </Card>
<TermsAndConditions onClose={()=>{
  setLoginData("")
}} isOpen={loginData?true:false} onAccept={()=>{
 if (["admin", "homeowner", "real_estate_agent", "broker"].includes(getDecodeUserType())) {
       
  dispatch(loginSuccess(loginData));
  navigate("/dashboard");
}
else {
    dispatch(loginSuccess(loginData));
    navigate("/pages-profile-settings");
 
}
setLoginData("")
CallAPIPostPromise("/login/update-terms",{
  user_email:email
}).catch(()=>{

})
}}/>
     
        <div className="login-screen__footer text-center text-xs mt-4 text-gray-500">
          <p>© 2025 {brandName}. All rights reserved.</p>
        </div>


      </div>
    </div>
    <Toaster position="top-center" />

    </div>
   
  );
}
